import React, { useContext, useEffect, useState } from "react";
import {
  AiOutlineShoppingCart,
  AiOutlineMenu,
  AiOutlineClose,
} from "react-icons/ai";
import { GoLocation, GoLock } from "react-icons/go";
import { Badge, Menu, MenuItem, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Link } from "react-router-dom";

import styles from "./index.module.css";
import { MainContext } from "../../utils/context";
import { api_call_token } from "../../utils/Network";
import {
  getSavedData,
  isMobiledevice,
  saveLocalData,
} from "../../utils/helperFunctions";
import LOGO from "../../assets/GRF_TM.png";
import Search from "../Search";
import LoginPopup from "../LoginPopup";
import AddressPopup from "../AddressPopup";

export default function Header() {
  const { userData, setUserData, cartData, setCartData } = useContext(
    MainContext
  );
  const [loginPopup, setLoginPopup] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [addressPopup, setAddressPopup] = useState(false);
  const [isActive, setActive] = useState(null);
  const [topBanner, setTopBanner] = useState(true);
  const [msg, setMsg] = useState("");

  useEffect(() => {}, [cartData]);
  useEffect(() => {
    if (userData.id) getAddress();
    else setAddresses([]);
  }, [userData.id]);

  const getAddress = () => {
    api_call_token
      .get("auth/address/view_address/")
      .then((res) => {
        if (res.status === 401) logoutHandler();
        else if (res.data.data?.length) {
          setAddresses(res.data.data);
          if (!getSavedData("addressName"))
            saveLocalData(
              "addressName",
              res.data.data[0].address1?.slice(0, 9)
            );
        } else setAddresses([]);
      })
      .catch((e) => console.log(e));
  };

  const logoutHandler = () => {
    setActive(false);
    api_call_token.post("auth/user/logout/", {
      user_id: userData.id,
      refresh: getSavedData("refreshToken")
        ? getSavedData("refreshToken")
        : getSavedData("accessToken"),
    });
    localStorage.removeItem("accessToken");
    localStorage.removeItem("adddressName");
    localStorage.removeItem("userData");
    localStorage.removeItem("cartData");
    setUserData({});
    setCartData([]);
  };

  return (
    <>
      <LoginPopup
        show={loginPopup}
        updateUser={userData.id ? userData : {}}
        onSuccess={(ms) => (setLoginPopup(false), setMsg(ms))}
        onClose={() => setLoginPopup(false)}
      />
      {addressPopup && (
        <AddressPopup
          show
          addresses={addresses}
          onSuccess={(ms) => (setAddressPopup(false), setMsg(ms))}
          onClose={() => setAddressPopup(false)}
        />
      )}
      <div className={styles.headerbg}>
        {topBanner && (
          <div className={styles.topBanner}>
            {isMobiledevice() ? (
              <marquee>
                {getSavedData("baseData")?.topBannerText
                  ? getSavedData("baseData").topBannerText.description
                  : "To avail custom Annual Maintenance Contracts (AMC) for any service, please contact us at +91 77383 98406"}
              </marquee>
            ) : (
              <span>
                {getSavedData("baseData")?.topBannerText
                  ? getSavedData("baseData").topBannerText?.description
                  : "To avail custom Annual Maintenance Contracts (AMC) for any service, please contact us at +91 77383 98406"}
              </span>
            )}
            <AiOutlineClose
              onClick={() => setTopBanner(false)}
              className={styles.closeBanner}
            />
          </div>
        )}
        <div className={styles.header}>
          <Link style={{ textDecoration: "none" }} to="/">
            <img
              style={{ marginTop: !topBanner ? 0 : "0.5vh" }}
              className={styles.logo}
              src={LOGO}
              alt="logo"
            />
          </Link>
          <Search />
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setAddressPopup(true)}
          >
            <GoLocation className={styles.locationIcon} />
            <h3 className={styles.headetText}>
              {getSavedData("addressName")
                ? getSavedData("addressName")
                : "Location"}
            </h3>
          </div>
          {userData?.id ? (
            <Link
              style={{ textDecoration: "none", color: "white" }}
              to="/orders"
              className={styles.headetText}
            >
              <h3>My Orders</h3>
            </Link>
          ) : (
            <div
              className={styles.headetText}
              style={{ cursor: "pointer" }}
              onClick={() => setLoginPopup(true)}
            >
              <h3>Login</h3>
            </div>
          )}
          <Link
            style={{ textDecoration: "none", color: "white" }}
            to="/proceed"
          >
            <Badge
              overlap="circular"
              max={5}
              badgeContent={cartData ? cartData.length : 0}
              color="secondary"
            >
              <AiOutlineShoppingCart className={styles.icon} />
            </Badge>
          </Link>
          {userData.id ? (
            <AiOutlineMenu
              onClick={() => setActive(true)}
              className={styles.menuicon}
            />
          ) : (
            <GoLock
              onClick={() => setLoginPopup(true)}
              className={styles.loginIcon}
            />
          )}
          {isActive && (
            <Menu
              style={{
                margin: isMobiledevice() ? "40px 0 0 0" : "50px 0 0 -50px",
              }}
              id="simple-menu"
              anchorEl={isActive}
              getContentAnchorEl={null}
              keepMounted
              open
              transformOrigin={{ vertical: "center", horizontal: "right" }}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              onClose={() => setActive(false)}
            >
              {/* <MenuItem onClick={() => setActive(false)}>
                {userData.complete_name
                  ? userData.complete_name
                  : userData.phone?.slice(2)}
              </MenuItem> */}
              {userData.id && (
                <>
                  {isMobiledevice() && (
                    <MenuItem onClick={() => setActive(false)}>
                      <Link
                        to="/orders"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        My Orders
                      </Link>
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => (setActive(false), setLoginPopup(true))}
                  >
                    Edit Profile
                  </MenuItem>
                  <MenuItem onClick={logoutHandler}>Logout</MenuItem>
                </>
                // ) : (
                //     <MenuItem
                //       onClick={() => (setActive(false), setLoginPopup(true))}
                //     >
                //       Login
                //     </MenuItem>
              )}
            </Menu>
          )}
          {/* <li
            style={{
              textDecoration: "none",
              color: "white",
              listStyleType: "none",
              cursor:"pointer"
            }}
            onClick={toggle}
          >
            <AiOutlineMenu className={styles.icon} />
            <div className={styles.nav + (isActive ? styles.nvs : "")}>
              <Link className={styles.hamnav} to="/orders">
                My Orders
              </Link>
              <li
                onClick={() => localStorage.removeItem("userData")}
                style={{
                  textDecoration: "none",
                  listStyleType: "none",
                  padding: "4px 10px",
                  cursor: "pointer",
                  backgroundColor:"#b1a5b9",
                  // borderRadius:8
                }}
              >
                Logout
              </li>
            </div>
          </li> */}
        </div>
      </div>
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity="success">{msg}</Alert>
        </Snackbar>
      )}
    </>
  );
}
